export default __webpack_public_path__ + "images/FT.719a4cd.png";